import React from 'react';

import { type FeedbackMetadata } from '../../common/types';
import { formatFeedbackTextWithMetadata } from '../../common/utils';

export const useFeedbackTextAndMetadata = ({
	allowFeedbackMetadata,
	feedbackMetadata,
}: {
	allowFeedbackMetadata: boolean;
	feedbackMetadata?: FeedbackMetadata;
}): {
	feedbackText: string;
	feedbackTextWithMetadata: string;
	includeHistoryFeedbackMetadata: boolean;
	setFeedbackText: React.Dispatch<React.SetStateAction<string>>;
	setIncludeHistoryFeedbackMetadata: React.Dispatch<React.SetStateAction<boolean>>;
} => {
	const [feedbackText, setFeedbackText] = React.useState('');

	const [includeHistoryFeedbackMetadata, setIncludeHistoryFeedbackMetadata] = React.useState(false);

	const feedbackTextWithMetadata = React.useMemo(() => {
		if (!allowFeedbackMetadata) {
			return formatFeedbackTextWithMetadata({
				message: feedbackText,
			});
		}

		const metadata = feedbackMetadata
			? {
					...feedbackMetadata,
				}
			: {};

		if (!includeHistoryFeedbackMetadata && metadata && 'history' in metadata) {
			delete metadata.history;
		}

		return formatFeedbackTextWithMetadata({
			message: feedbackText,
			metadata,
		});
	}, [feedbackMetadata, feedbackText, allowFeedbackMetadata, includeHistoryFeedbackMetadata]);

	return {
		feedbackText,
		setFeedbackText,
		includeHistoryFeedbackMetadata,
		setIncludeHistoryFeedbackMetadata,
		feedbackTextWithMetadata,
	};
};
